import { Injectable, Optional } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { interval } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UpdateService {
  constructor(@Optional() private swUpdate: SwUpdate) {
    if (this.swUpdate) {
      this.checkForUpdates();
    } else {
      console.log('Service worker updates are disabled. Running in development mode or service worker not supported.');
    }
  }

  checkForUpdates(): void {
    if (this.swUpdate && this.swUpdate.isEnabled) {
      // Check for updates every 6 hours
      interval(6 * 60 * 60 * 1000).subscribe(() => {
        this.swUpdate.checkForUpdate().then(() => console.log('Checking for updates'));
      });

      // When an update is available, automatically apply it
      this.swUpdate.versionUpdates.subscribe(event => {
        if (event.type === 'VERSION_READY') {
          console.log('New version available');
          // Prompt user or automatically update
          if (confirm('A new version of the app is available. Load it now?')) {
            window.location.reload();
          }
        }
      });
    }
  }

  // Method to manually check for updates
  checkForUpdate(): Promise<boolean> {
    if (!this.swUpdate || !this.swUpdate.isEnabled) {
      console.log('Service worker is not enabled');
      return Promise.resolve(false);
    }
    return this.swUpdate.checkForUpdate();
  }

  // Helper method to check if updates are available
  isEnabled(): boolean {
    return !!this.swUpdate && this.swUpdate.isEnabled;
  }
  
  // Method to manually refresh the app
  refreshApp(): void {
    console.log('Manually refreshing the app');
    // First check for updates if service worker is enabled
    if (this.swUpdate && this.swUpdate.isEnabled) {
      this.swUpdate.checkForUpdate()
        .then(hasUpdate => {
          if (hasUpdate) {
            console.log('Update available, applying...');
          } else {
            console.log('No updates available, refreshing page anyway');
          }
          // Refresh the page regardless of update status
          window.location.reload();
        })
        .catch(err => {
          console.error('Error checking for updates:', err);
          // Still refresh the page even if checking for updates fails
          window.location.reload();
        });
    } else {
      // If service worker is not enabled, just reload the page
      window.location.reload();
    }
  }
}
